import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { RoutesService } from '../../../../../../services/routes.service';
import { BroadcastService } from '../../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../../shared/services/form.service';
import { RutasModel } from '../../models/rutas.model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'rutas-edit-create',
    templateUrl: './edit-create.component.html',
    styleUrls: ['./edit-create.component.scss']
})
export class RutasEditCreateComponent implements OnInit, OnDestroy {
    @Input() data: any = {};
    formGroup: RxFormGroup;
    subscriptions: Array<Subscription> = [];

    constructor(
        public modalRef: BsModalRef,
        private broadcast: BroadcastService,
        private formService: FormService,
        private routesService: RoutesService
    ) {
        this.subscriptions.push(
            this.formService._formEvents.subscribe(data => {
                this.formGroup = data;
            })
        );
    }

    ngOnInit(): void {
        this.formService.transformIntoFormGroup(RutasModel, Object.assign(this.data, { active: true }));

        if ('id' in this.data) {
            this.subscriptions.push(
                this.routesService.show(this.data.id).subscribe(
                    data => {
                        this.formGroup.patchModelValue(data);
                    }
                )
            );
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
    }

    /**
   *
   */
    submit(): void {
        this.subscriptions.push(
            this.routesService.createOrUpdate(this.formGroup, this.data?.id).subscribe(
                data => {
                    this.broadcast.reloadDataTable();
                    this.modalRef.hide();
                }
            )
        );
    }

}
